import React, { useCallback } from 'react';
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import "./modalCom.css"
const ModalCommunication = (props) => {
  const { description, open, onClose } = props;

  const handleClose = useCallback(() => {
    onClose(false);
  }, [onClose]);

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      id="modalCommunication"
    >
      <div style={{ position: "relative" }}>
        
        <DialogContent style={{ color: "#69509B" }}>
          {description}
        </DialogContent>
        <IconButton
            onClick={handleClose}
            style={{
              position: "absolute",
              top: "8px",
              right: "8px",
            }}
          >
            <CloseIcon />
          </IconButton>
                </div>
    </Dialog>
  );
};

export default ModalCommunication;
